import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { setupRouteGuards } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

setupRouteGuards(router)

export default router
